/* eslint-disable no-undef */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import NoSequenceIcon from 'Assets/salesgear/png/noSequence.png';
import { SALESGEAR_URL, MX_EVENTS_AE } from 'Utils/constants';
import Utils from 'Utils/utils';

const NoSequenceComponent = () => {
  const redirectToSalesgear = () => {
    if (SALESGEAR_URL) window.open(SALESGEAR_URL, '_blank', 'noopener');
    Utils.mixpanelTrack(MX_EVENTS_AE.createSeqClicked);
  };

  useEffect(() => {
    Utils.mixpanelTrack(MX_EVENTS_AE.createSeqShown);
  }, []);

  return (
    <div className="emptySequence">
      <img src={NoSequenceIcon} alt="" />
      <span>You don't have any sequences in this folder</span>
      <button
        id="newSequence"
        name="newSequence"
        type="button"
        className="createSeqeucneBtn"
        onClick={redirectToSalesgear}
      >
        <span>Create a Sequence</span>
      </button>
    </div>
  );
};

export default observer(NoSequenceComponent);
export { NoSequenceComponent };
